import React, {createRef} from "react";

import SwipeOutFadeIn from "./SwipeOutFadeIn";

import IconButton from "@mui/material/IconButton";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import Box from "@mui/material/Box";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";


const Swiper = ({onNext, onPrev, hasNext, hasPrev, headerEl, subHeaderEl, children}) => {
    const swipeRef = createRef();

    const triggerSwipeRight = () => {
        swipeRef.current.swipeOutRight();
    }

    const triggerSwipeLeft = () => {
        swipeRef.current.swipeOutLeft();
    }

    const justifyContent = hasNext || hasPrev ? 'space-between' : 'center';

    return <>
        <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: justifyContent, alignItems: 'center', my: 2}}>
            {
                hasNext &&
                <IconButton aria-label="before" onClick={triggerSwipeRight}>
                    <NavigateBeforeIcon/>
                </IconButton>
            }
            {
                !!headerEl && headerEl
            }
            {
                hasPrev &&
                <IconButton aria-label="next" onClick={triggerSwipeLeft}>
                    <NavigateNextIcon/>
                </IconButton>
            }
        </Box>
        {subHeaderEl && subHeaderEl}
        <SwipeOutFadeIn ref={swipeRef}
                        onSwipeLeft={onNext}
                        onSwipeRight={onPrev}>
            {children}
        </SwipeOutFadeIn>
    </>
}

export default Swiper;